import { CONTEXT_QUERY_PARAM } from '@constants/query-params';
import { OfferListContext } from '@constants/query-params.type';
import {} from '@domain/admission';
import { useGenericQuery } from '@hooks/use-generic-query';
import { GenericQueryOptions } from '@hooks/use-generic-query.type';
import { request } from '@utils/request/request';
import { RequestError, RequestMethod } from '@utils/request/request.type';

import { QUERY_KEYS } from './constants.type';
import type { AdmissionResponse } from './use-get-admissions.type';

// The import context returns a role-filtered list, so it must not share a cache entry with the management screens.
export const getAdmissionsQueryKey = (eventId: string, context?: OfferListContext) =>
  context ? [QUERY_KEYS.getAdmissions, eventId, { context }] : [QUERY_KEYS.getAdmissions, eventId];

const getAdmissionsByEventId = async (eventId: string, context?: OfferListContext) => {
  const searchParams = new URLSearchParams();
  if (context) searchParams.set(CONTEXT_QUERY_PARAM, context);
  const query = searchParams.toString();
  const search = query ? `?${query}` : '';
  const url = `${import.meta.env.VITE_OFFERS_HOST}/v1/nightgraph/events/${eventId}/admissions${search}`;

  return request({ url, method: RequestMethod.GET });
};

export const useGetAdmissions = ({
  eventId,
  context,
  options,
}: {
  eventId: string;
  context?: OfferListContext;
  options?: GenericQueryOptions<AdmissionResponse, RequestError>;
}) => {
  return useGenericQuery<AdmissionResponse, RequestError>(
    getAdmissionsQueryKey(eventId, context),
    () => getAdmissionsByEventId(eventId, context),
    options
  );
};
